// ============================================================================
// LINGALA TRANSLATIONS - CHAPTER 8: LISALISI YA NKOLO-NKOLO (BONUS)
// ============================================================================
// Niveau 92 (1 niveau bonus, mituna 3)

export const chapter8Translations = {
  name: "Lisalisi ya Nkolo-Nkolo",
  description: "Oyo afandaka na ebombamelo ya Nzambe-Likolo, akofanda na elili ya Nkolo-Nyonso",
  
  spiritualWisdom: {
    principle: "Okomi na songe ya ngomba, mpe boyebi ezwami",
    scripture: "Oyo afandaka na ebombamelo ya Nzambe-Likolo, akofanda na elili ya Nkolo-Nyonso (Nzembo 91:1)",
    application: "Kondima oyo eninganaka te esengaka makambo ya bomoi, mawa, mpe bolingo ya solo ya Yesu. Ba épreuves ekotala motema na yo, nzela ya solo oyo oponaki."
  },
  
  levels: {
    92: {
      name: "Ebombamelo ya Nzambe-Likolo",
      challenge: "Ozali na songe ya ngomba... Kasi kondima oyo eninganaka te ebandi sik'oyo...",
      easy: {
        question: "Yesu azali nani mpo na yo na ndenge ya moto?",
        options: [
          "Profeta ya pamba",
          "Nkolo na Mobikisi na ngai ya moto",
          "Lisese",
          "Philosophe"
        ],
        hint: "Azali oyo apesaka bomoi na ye mpo na kobikisa biso",
        funFact: "✝️ Yesu azali Nzambe! Azali kaka te moto ya histoire - Azali na bomoi mpe alingi kozala na boyokani ya moto na moto moko na biso!"
      },
      medium: {
        question: "Mpo na nini kokila lokola Daniel epesaka biso nzela ya koyoka Nzambe malamu?",
        options: [
          "Mpo na kokita kilo",
          "Mpo na komiboya oyo tolingaka mpe kozala na motema oyo ebongwani",
          "Mpo na kosepelisa bato mosusu",
          "Mpo na kozala makasi mingi"
        ],
        hint: "Miboya oyo olingaka mingi, na kimia mpe na bwanya",
        funFact: "🙏 Kokila ya molimo ebongisaka mitema na biso mpo na mbongwana ya mozindo - mbala mingi na mpasi - oyo ekembisaka biso na Nzambe!"
      },
      hard: {
        question: "Nini eyano ya solo ya motema liboso ya boyebi nyonso oyo ezwami?",
        options: [
          "Sik'oyo nazali parfait",
          "Napesi yo motema na ngai Yesu mpe nalingi kobatisama",
          "Nayebi malamu koleka bato mosusu",
          "Nazali lisusu na mposa ya lisalisi te"
        ],
        hint: "Kondima ya solo ememi na komikaba mobimba mpe kozwa mikano na Yesu",
        funFact: "🌟✨ Okomi na songe ya ngomba, mpe boyebi ezwami ✨\n\n💖 Kondima oyo eninganaka te esengaka makambo ya bomoi, mawa, mpe bolingo ya solo ya Yesu 💖\n\n🔥 Ba épreuves ndenge na ndenge ya bomoi ekotala nzela na yo, nzela ya solo oyo toponaka, mitema na biso 🔥\n\n😔 Tokobaki kozanga malamu, bamposa na biso ezali mingi, mpe bolingo ya lifuti to bobateli malamu ya moto azali mbala mingi kokoma likambo na biso ya motema mabe 😔\n\n🙏 Sengela Nzambe bwanya, bolingo na ye, makasi na ye, mpe yamba bampasi na yo na bomikoki te, mpo tokoki kobomba na ye eloko moko te... Eloko moko te 🙏\n\n🥖 Kila lokola Daniel: miboya mwa ntango oyo olingaka mingi, na kimia mpe na bwanya 🥖\n\n💫 Yango ekopesa yo nzela ya koyoka Nzambe malamu, kozala na motema oyo ebongani mpo na mbongwana ya mozindo 💫\n\n🌙 Na yango, bandoto mpe bimoniseli ekokoma polele, lokola mpo na Yosefu 🌙\n\n⚠️ Kebisa yo mpo na lofundu: kokweya te na 'nazali tango nyonso na racio' to 'nayebi malamu' ⚠️\n\n🎁 Mpo komonisama ya Nzambe ezali ngolu ya kokamwa 🎁\n\n💝 Kozala na kondima ezali kokota na boyokani mpe nzela ya bonsomi ya motema 💝\n\n🦸‍♂️ Ekosala yo ba héros ya nguya, oyo bakoki kosala oyo ekoki te 🦸‍♂️\n\n✝️ Na songe ya boyebi, motema ya solo alobi: 'Napesi yo motema na ngai Yesu mpe nalingi kobatisama' ✝️\n\n🏔️ Okomi na songe ya ngomba, kanga makasi, tikala na molende! 🏔️\n\n⬇️ Esengeli kokita mpe komeme bozwi oyo ya talo: elikya ya bomoi ya seko ⬇️\n\n🏆✨ MALAMU! TOZALI NA LOLENDO NA YO ✨🏆\n🌟 MPIKO MOBATELI YA KIMIA YA MPIKO 🌟\n🕊️✨ NZAMBE APAMBOLA YO ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
